import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { STATES, FILING_STATUS } from '../../../../services/constant/constant';
import { Filings } from '../../services/Filings';

const dateFormatter = new Intl.DateTimeFormat('en-US');

class PendingFilingsListGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHolds: false
        };
        this.columns = [
            {
                title: '<span class="glyphicon glyphicon-ok" />',
                data: null,
                defaultContent: ''
            },
            {
                title: 'Status',
                data: 'filingStatus'
            },
            {
                title: 'Client<br/>Name',
                data: 'clientName'
            },
            {
                title: 'Request<br/>Date',
                data: 'requestDateTime'
            },
            {
                title: '',
                data: 'stateId'
            },
            {
                title: 'Priority',
                data: 'isPriority'
            },
            {
                title: 'Trust<br/>Name',
                data: 'trustName'
            },
            {
                title: 'Portfolio<br/>Name',
                data: 'portfolioName'
            },
            {
                title: 'Class<br/>Name',
                data: 'className'
            },
            {
                title: 'Prospectus<br/>Name',
                data: 'prospectusName'
            },
            {
                title: 'Process<br/>Hold Until',
                data: 'holdUntilDate',
                defaultContent: ''
            }
        ];

        this.columnFormat = [
            { orderable: false, targets: [6, 7, 8, 9, 10, 11, 12] },
            {
                targets: [0],
                orderable: false,
                className: 'select-checkbox',
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('min-width', '20px');
                }
            },
            {
                targets: [1],
                className: 'text-center',
                render: (data, type, full) => {
                    let filingStatusName = Filings.getFilingStatusName(data);
                    return filingStatusName + (full.isSalesReport ? '*' : '');
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    if (rowData.isSalesReport) {
                        td.title = 'In Progress (Sales)';
                    }
                }
            },
            {
                targets: [3],
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('max-width', '165px');
                    td.title = cellData;
                }
            },
            {
                targets: [5],
                render: function(data, type, full) {
                    return data ? 'Yes' : 'No';
                }
            },
            {
                targets: [3, 10],
                className: 'text-center',
                render: function(data, type, full) {
                    if (data) {
                        if (type === 'sort') {
                            return data;
                        } else {
                            let date = new Date(data);
                            return dateFormatter.format(date);
                        }
                    }
                }
            },
            {
                targets: [4],
                render: function(data, type, full) {
                    if (data) {
                        return STATES[data].code;
                    }
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    td.title = STATES[cellData].name;
                    $(td).css('width', '3%');
                    $(td).css('text-align', 'center');
                }
            },
            {
                targets: [6, 7, 8, 9, 10],
                createdCell: function(td, cellData, rowData, row, col) {
                    $(td).css('max-width', '120px');
                    td.title = cellData;
                }
            }
        ];
        if (props.showReviewColumn) {
            this.columns.push({
                title: 'Review',
                data: null
            });
            this.columnFormat.push({
                targets: [11],
                width: '5%',
                className: 'text-center',
                render: function(data, type, full) {
                    return '<span class="label label-default" title="Review" style="cursor: pointer; font-size: 90%"><span class="glyphicon glyphicon-search"></span></button>';
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    let data = cellData;
                    $(td).css('max-width', '5px');
                    $(td).click(cellData => {
                        props.handleReviewButtonClick(data);
                    });
                }
            });
        }
        if (props.showHoldCancelColumn) {
            this.columns.push({
                title: 'Hold/Cancel',
                data: null
            });
            this.columnFormat.push({
                targets: [12],
                width: '5%',
                className: 'text-center',
                render: function(data, type, full) {
                    let cursor = '';
                    let title = '';

                    if (data.filingStatus === FILING_STATUS.IN_PROGRESS) {
                        cursor = 'not-allowed';
                        title = 'In progress filings can not be hold';
                    } else {
                        cursor = 'pointer';
                        title = 'Hold';
                    }

                    if (data.filingStatus !== FILING_STATUS.ON_HOLD)
                        return (
                            '<span class="label label-default" title="' +
                            title +
                            '" style="cursor: ' +
                            cursor +
                            '; font-size: 90%"><span class="glyphicon glyphicon-pause"></span></span>  ' +
                            '<span class="label label-default" title="Cancel" style="cursor: pointer; font-size: 90%"><span class="glyphicon glyphicon-remove-sign"></span></span>'
                        );
                    else return '';
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    let data = cellData;
                    if (data.filingStatus !== FILING_STATUS.IN_PROGRESS) {
                        $(td.children[0]).click(cellData => {
                            props.handleHoldButtonClick(data);
                        });
                    }
                    $(td.children[1]).click(cellData => {
                        props.handleCancelButtonClick(data);
                    });
                }
            });
        }
    }

    componentWillUnmount() {
        let { updateSelected } = this.props;
        updateSelected([]);
    }

    onShowHoldsButtonClick = () => {
        let { id } = this.props;
        let { showHolds } = this.state;
        let table = $('#' + id).DataTable();
        this.setState({
            showHolds: !showHolds
        });
        table.rows().every(function(rowIdx, tableLoop, rowLoop) {
            let row = this.node();
            let data = this.data();
            if (data.filingStatus === FILING_STATUS.ON_HOLD) {
                if (showHolds) {
                    $(row).removeClass('hold-filing');
                    $(row).addClass('hidden');
                } else {
                    $(row).addClass('hold-filing');
                    $(row).removeClass('hidden');
                }
            }
            return true;
        });
        let btn = table.buttons('showHoldsButton:name')[0].node;
        if (showHolds) {
            $(btn).removeClass('active');
        } else {
            $(btn).addClass('active');
        }
    };

    render() {
        let { id, dataList, updateSelected } = this.props;
        return (
            <DataTable
                id={id}
                columns={this.columns}
                data={dataList}
                checkBoxSelection={true}
                showButtons
                buttons={[
                    {
                        name: 'showHoldsButton',
                        text: 'Show Holds',
                        className: 'btn-sm',
                        action: this.onShowHoldsButtonClick
                    }
                ]}
                pageable
                searchable
                sortable
                order={[['1', 'asc']]}
                onSelectedItems={data => {
                    updateSelected(data);
                }}
                columnFormat={this.columnFormat}
                rowFormat={(row, data, dataIndex) => {
                    if (data.filingStatus === FILING_STATUS.ON_HOLD) {
                        $(row).addClass('hidden');
                    }
                    //$(row).css('cursor', 'pointer');
                }}
            />
        );
    }
}

PendingFilingsListGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    showReviewColumn: PropTypes.bool,
    showHoldCancelColumn: PropTypes.bool,
    handleReviewButtonClick: PropTypes.func,
    handleHoldButtonClick: PropTypes.func,
    handleCancelButtonClick: PropTypes.func
};

PendingFilingsListGrid.defaultProps = {
    singleSelection: false
};

export default PendingFilingsListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingFilings/PendingFilingsListGrid.js